var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item-box" }, [
    _c(
      "div",
      { staticClass: "title" },
      [
        _vm._t("titleY"),
        _c(
          "span",
          {
            class: ["showMore", { isOpen: _vm.isOpen }],
            on: { click: _vm.showMore },
          },
          [
            _vm._v(_vm._s(_vm.isOpen ? "展开" : "收起")),
            _c("i", { staticClass: "el-icon-arrow-down" }),
          ]
        ),
      ],
      2
    ),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isOpen,
            expression: "!isOpen",
          },
        ],
        staticClass: "tabbox",
      },
      [_vm._t("default")],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }